<template>


	<v-carousel cycle hide-delimiter-background show-arrows-on-hover height="auto">
		<!-- <v-carousel-item class="ma-0 pa-0">

			<a
				href="#"
				rel="noopener noreferrer"
				>
				<picture>
					<source media="(min-width: 2800px)" srcset="/images/preventabeelecucuta/banner_x2_2880.webp" />
					<source media="(min-width: 2160px)" srcset="/images/preventabeelecucuta/banner_x2_2528.webp" />
					<source media="(min-width: 1920px)" srcset="/images/preventabeelecucuta/banner_x2_1920.webp" />
					<source media="(min-width: 1600px)" srcset="/images/preventabeelecucuta/banner_x1_1880.webp" />
					<source media="(min-width: 1440px)" srcset="/images/preventabeelecucuta/banner_x1_1440.webp" />
					<source media="(min-width: 1264px)" srcset="/images/preventabeelecucuta/banner_x1_1264.webp" />
					<source media="(min-width: 850px)" srcset="/images/preventabeelecucuta/banner_x1_960.webp" />
					<source media="(min-width: 600px)" srcset="/images/preventabeelecucuta/banner_x1_600.webp" />
					<img src="/images/preventabeelecucuta/banner_x1_360.webp" alt="Banner del evento" class="responsive-img" />
				</picture>
			</a>


		</v-carousel-item> -->
		<v-carousel-item class="ma-0 pa-0" v-for="(evento, index) in eventos" :key="index">

			<router-link :to="{
				name: 'evento',
				params: {
					evento: evento.imagen.slug,
				},
			}">

				<picture>
					<source media="(min-width: 2800px)" class="responsive-img"
						:srcset="getSrcSet(evento, { width: 2880, name: 'banner_x2_2880' })" />
					<source media="(min-width: 2160px)"
						:srcset="getSrcSet(evento, { width: 2160, name: 'banner_x2_2528' })" />
					<source media="(min-width: 1920px)"
						:srcset="getSrcSet(evento, { width: 1920, name: 'banner_x2_1920' })" />
						<source media="(min-width: 1600px)"
						:srcset="getSrcSet(evento, { width: 1440, name: 'banner_x1_1880' })" />
					<source media="(min-width: 1440px)"
						:srcset="getSrcSet(evento, { width: 1440, name: 'banner_x1_1440' })" />
					<source media="(min-width: 1264px)"
						:srcset="getSrcSet(evento, { width: 1264, name: 'banner_x1_1264' })" />
					<source media="(min-width: 850px)" :srcset="getSrcSet(evento, { width: 960, name: 'banner_x1_960' })" />
					<source media="(min-width: 600px)" :srcset="getSrcSet(evento, { width: 600, name: 'banner_x1_600' })" />
					<img cover :src="getSrcSet(evento, { width: 360, name: 'banner_x1_360' })" class="responsive-img" :alt="`Banner del evento ${evento.imagen.nombre}`"/>

				</picture>

			</router-link>

		</v-carousel-item>

		<div v-if="eventos == null">
			<v-carousel-item :key="index" v-for="(n, index) in 7"
				src="http://placehold.it/1200x480/888/FFF"></v-carousel-item>
		</div>
	</v-carousel>







</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'


import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
	components: {
		VueSlickCarousel
	},
	data() {
		return {
			settings: {
				"arrows": false,
				"dots": true,
				"infinite": true,
				"slidesToShow": 1,
				"slidesToScroll": 1,
				"initialSlide": 0,
				"autoplay": true,
				"speed": 1500,
				"autoplaySpeed": 4000,
				"lazyLoad": "ondemand",
				"cssEase": "ease-out",
				"responsive": [
					{
						"breakpoint": 960,
						"settings": {
							"lazyLoad": 'progressive',
							"dots": true,
							"infinite": true,
							"speed": 600,
							"cssEase": 'ease-out',
							"autoplaySpeed": 4000,
							"slidesToShow": 1,
							"slidesToScroll": 1
						}
					},
					{
						"breakpoint": 600,
						"settings": {
							"slidesToShow": 1,
							"slidesToScroll": 1,
							"initialSlide": 2
						}
					},
					{
						"breakpoint": 400,
						"settings": {
							"arrows": false,
							"touchMover": true,
							"dots": false,
							"infinite": true,
							"focusOnSelect": true,
							"slidesToShow": 1,
							"slidesToScroll": 1,
							"touchThreshold": 4,
							"speed": 500,
						}
					}
				]
			},
		};
	},
	props: [
		'eventos',
		'redirect'
	],
	computed: {
		defaultImageUrl() {
			// Busca la imagen por defecto (la de menor resolución o la primera disponible)
			const imagenFija = this.evento.imagen.imagens.find(imagen =>
				imagen.nombre.includes('banner_x2_720')

			);
			return imagenFija ? imagen.url : '';
		}
	},
	methods: {
		getSrcSet(evento, resolucion) {
			// Buscar la imagen correspondiente a la resolución actual
			const imagen = evento.imagen.imagens.find(imagen =>
				imagen.nombre.includes(resolucion.name)

			);
			// Si la imagen existe para esa resolución, devolver la URL, sino devolver una cadena vacía
			return imagen ? imagen.url : '';
		},
	},
	created() { },
	mounted() { }
};
</script>

<style scoped>
.responsive-img {
	width: 100%;
	height: auto;
	object-fit: cover;
	aspect-ratio:  auto 2/3;


}

@media (min-width: 600px) and (max-width: 719px) {
	.responsive-img {
		height: 100%;
		aspect-ratio: 25/36;

	}

}

@media (min-width: 850px) and (max-width: 1239px) {
	.responsive-img {
		
		aspect-ratio: 160/59;

	}

}

@media (min-width: 1240px) {
	.responsive-img {
		height: 528px;
		aspect-ratio:632/233;

	}
}
@media (min-width: 1440px) {
	.responsive-img {
		height: 100%;
		aspect-ratio: 9/4;

	}
}

@media (min-width: 1600px) {
	.responsive-img {
		height: 100%;
		aspect-ratio: 470/173;

	}
}

@media (min-width: 1920px) {
	.responsive-img {
		height: 100%;
		aspect-ratio: 160/59;


	}

}
@media (min-width: 2160px) {
	.responsive-img {
		height: 100%;
		aspect-ratio:632/233;
		


	}
}
	@media (min-width: 2880px) {
	.responsive-img {
		
		aspect-ratio: 9/4;


	}

}
</style>
